import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import useLoadingStore from '../stores/useLoadingStore'

const PageNotFound = () => {
    const { t } = useTranslation()
    const { setLoading } = useLoadingStore()

    useEffect(() => {
        setLoading(false)
    }, [])

    return (
        <StyledContainer>
            <StyledContent>
                <StyledTextHeading>404</StyledTextHeading>
                <Typography variant="h3">Page Not Found</Typography>
            </StyledContent>
            <StyledButton variant="contained" color="primary">
                <StyledLink to="/">{t('BUTTON.GO_TO_HOMEPAGE')}</StyledLink>
            </StyledButton>
        </StyledContainer>
    )
}

export default PageNotFound

const StyledContainer = styled('div')(({ theme }) => ({
    textAlign: 'center',
}))

const StyledContent = styled('div')(({ theme }) => ({
    marginBottom: '10vh',
}))

const StyledTextHeading = styled(Typography)(({ theme }) => ({
    fontSize: '30vh',
}))

const StyledButton = styled(Button)(({ theme }) => ({
    padding: '10px 40px',
}))

const StyledLink = styled(Link)(({ theme }) => ({
    color: 'inherit',
    textDecoration: 'none',
}))
